<template>
  <h1>landing pages</h1>
</template>